<template>
  <div>
    <h1>Add holiday</h1>
    <v-alert :value="true" type="info"
      >Choose a conveyancer or leave it blank if you are creating a public
      holiday. Set a start date for the holiday. If the holiday is only one day
      leave the end date blank otherwise set an end date. Then click save to add
      it to the calendar.</v-alert
    >
    <v-select
      label="Entity"
      v-model="id"
      :items="entities"
      item-value="id"
      outline
      v-if="entities"
    >
      <template slot="selection" slot-scope="data">{{
        nameFormatted(data.item)
      }}</template>
      <template slot="item" slot-scope="data">{{
        nameFormatted(data.item)
      }}</template>
      <template slot="append-outer" v-if="id">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a @click="id = null" v-on="on">
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Clear entity</span>
        </v-tooltip>
      </template>
    </v-select>
    <DateDropdown v-model="start" label="Start date" />
    <DateDropdown v-model="end" label="End date" :min="min" />
    <v-btn @click="saveHoliday"> <v-icon>save</v-icon>Save </v-btn>
    <v-alert :value="alertError" type="error">{{ alertErrorText }}</v-alert>
  </div>
</template>

<script>
import DateDropdown from "@/components/date/DateDropdown";
import nbmlaw from "@/api/nbmlaw";
import { nameFormatted } from "@/util/helpers";
export default {
  name: "HolidayAdd",
  metaInfo() {
    return {
      title: "Holiday add",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    DateDropdown
  },
  data() {
    return {
      id: this.$route.query.id ? this.$route.query.id : null,
      entities: null,
      start: new Date().toISOString().slice(0, 10),
      end: null,
      min: null,
      alertError: false,
      alertErrorText: null
    };
  },
  methods: {
    fetchEntities() {
      nbmlaw
        .get(`/cors/admin/directory/types/2/entities`)
        .then((response) => {
          // console.log(response.data);
          this.entities = response.data;
          this.entities = this.entities.filter((e) => !e.deny);
        })
        .catch(() => {});
    },
    nameFormatted(entity) {
      return entity ? nameFormatted(entity.name, "index") : "Public holiday";
    },
    saveHoliday() {
      if (this.id) {
        this.createHoliday();
      } else {
        this.createHolidayPublic();
      }
    },
    createHoliday() {
      nbmlaw
        .post(`/cors/admin/directory/entities/${this.id}/holidays`, null, {
          params: { start: this.start, end: this.end }
        })
        .then(() => {
          // console.log(response.data);
          this.$router.push({ name: "holidayEntity", params: { id: this.id } });
        })
        .catch((error) => {
          // console.log(error.response);
          this.alertError = true;
          this.alertErrorText = error.response.data;
        });
    },
    createHolidayPublic() {
      nbmlaw
        .post(`/cors/admin/directory/holidays/public`, null, {
          params: { start: this.start, end: this.end }
        })
        .then(() => {
          // console.log(response.data);
          this.$router.push({ name: "holidayEntityPublicHoliday" });
        })
        .catch((error) => {
          // console.log(error.response);
          this.alertError = true;
          this.alertErrorText = error.response.data;
        });
    }
  },
  watch: {
    start: {
      immediate: true,
      handler() {
        const start = new Date(this.start);
        this.end = null;
        this.min = start.toISOString();
      }
    }
  },
  created() {
    this.fetchEntities();
  }
};
</script>
